import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ThemeProvider } from '@heyroot/ui/theme';
import { initFirebase } from './lib/firebase-config';
import { AuthProvider, useAdminAuth } from './lib/auth-context';
import { router } from './router';
import '@fontsource-variable/geist/index.css';
import './styles.css';
import { initSentryWeb, ErrorBoundary } from '@heyroot/sentry-web';
import { env } from './env';

initSentryWeb({
  dsn: env.SENTRY_DSN,
  environment: env.HEYROOT_ENV,
  release: `admin@${env.BUILD_SHA}`,
  app: 'admin',
});

initFirebase();
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

function App() {
  const auth = useAdminAuth();
  useEffect(() => {
    if (auth.status === 'loading') return;
    void router.invalidate();
  }, [auth.status]);
  return <RouterProvider router={router} context={{ auth, queryClient }} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <ThemeProvider initialMode="auto">
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
